<div class="wrapper">
  <div class="initial-step">
    <div class="initial-step-header">
      <div class="header-text-wrapper">
        <h2 class="initial-step-header-main font">
          {{ data.length }} {{ getSingularOrPlural(data.length) }} nepopunjeno
          polje
        </h2>
        <span class="description">Please enter the blank fields manually.</span>
      </div>
      <div class="header-actions">
        <button
          class="accent-button remove-bg"
          mat-button
          [disabled]="data.length === 1"
          (click)="changeStep(data[imageIndex])"
        >
          NEXT
        </button>
        <button class="action-button" (click)="skipAndDownload()">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_766_11991"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_766_11991)">
              <path
                d="M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z"
                fill="white"
              />
            </g>
          </svg>
          SKIP AND DOWNLOAD
        </button>
      </div>
    </div>
    <div class="carousel-wrapper">
      <div class="slide-wrapper">
        <div class="slide">
          <div>
            <ng-container
              *ngIf="!data[imageIndex]?.thumbnailPath; else withThumbnail"
            >
              <lib-ngx-image-zoom
                (click)="
                  openDocumentEmitter(
                    data[imageIndex].name.endsWith('.pdf'),
                    data[imageIndex].name
                  )
                "
                thumbImage="{{
                  data[imageIndex]?.name.endsWith('.pdf')
                    ? localImages.fileDocument
                    : data[imageIndex]?.name.endsWith('.txt')
                      ? localImages.textFileDocument
                      : data[imageIndex]?.name
                }}"
                fullImage="{{
                  data[imageIndex]?.name.endsWith('.pdf')
                    ? localImages.fileDocument
                    : data[imageIndex]?.name.endsWith('.txt')
                      ? localImages.textFileDocument
                      : data[imageIndex]?.name
                }}"
                [zoomMode]="'hover-freeze'"
                [magnification]="0.7"
                [enableLens]="true"
                [lensWidth]="200"
                [lensHeight]="140"
              >
              </lib-ngx-image-zoom>
            </ng-container>

            <ng-template #withThumbnail>
              <lib-ngx-image-zoom
                (click)="
                  openDocumentEmitter(
                    data[imageIndex].name.endsWith('.pdf'),
                    data[imageIndex].name
                  )
                "
                thumbImage="{{ data[imageIndex]?.thumbnailPath }}"
                fullImage="{{ data[imageIndex]?.thumbnailPath }}"
                [zoomMode]="'hover-freeze'"
                [magnification]="0.7"
                [enableLens]="true"
                [lensWidth]="200"
                [lensHeight]="140"
              >
              </lib-ngx-image-zoom>
            </ng-template>
          </div>
          <div class="input-wrapper" #inputWrapper>
            <div
              *ngFor="let input of data[imageIndex]?.inputs"
              class="slide-inputs"
            >
              <mat-form-field class="form-field" appearance="outline" [hideRequiredMarker]="true">
                <mat-label>{{ input.heading }}</mat-label>
                <input
                  type="text"
                  placeholder="Molimo unesite podatke"
                  matInput
                  [(ngModel)]="input.value"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
